<template>
    <table class="table">
        <thead class="gray">
            <tr>
                <th style="width: 5%">#</th>
                <th style="width: 15%">Data/Hora</th>
                <th style="width: 10%">Método</th>
                <th style="width: 25%">URL</th>
                <th style="width: 10%">Status</th>
                <th style="width: 10%">Tempo (ms)</th>
                <th style="width: 10%">Tentativa</th>
                <th style="width: 10%">Detalhes</th>
            </tr>
        </thead>
        <tbody>
            <template v-for="(attempt, idx) in webhook_attempts">
                <tr :key="'attempt-' + attempt.id">
                    <td>{{ attempt.id }}</td>
                    <td>{{ attempt.attempted_at | formatDate }}</td>
                    <td>
                        <span class="method-badge">{{ attempt.http_method }}</span>
                    </td>
                    <td class="text-truncate" :title="attempt.url">
                        {{ attempt.url }}
                    </td>
                    <td>
                        <span class="status-badge" :class="attempt.is_successful ? 'success' : 'error'">
                            {{ attempt.is_successful ? "Sucesso" : "Erro " + (attempt.response_status || "") }}
                        </span>
                    </td>
                    <td>{{ attempt.response_time_ms }}</td>
                    <td>{{ attempt.attempt_number }}</td>
                    <td class="text-center">
                        <span
                            class="material-icons details-btn"
                            @click="toggleDetails(idx)"
                            :title="attempt.showDetails ? 'Ocultar detalhes' : 'Mostrar detalhes'"
                        >
                            {{ attempt.showDetails ? "expand_less" : "expand_more" }}
                        </span>
                    </td>
                </tr>
                <tr v-if="attempt.showDetails" :key="'details-' + attempt.id">
                    <td colspan="8">
                        <div class="details-section">
                            <div class="row">
                                <div class="col-md-6">
                                    <h6>Informações da Requisição</h6>
                                    <div class="info-row">
                                        <strong>Evento:</strong>
                                        <span>{{ attempt.request_body.event_type || "N/A" }}</span>
                                    </div>
                                    <div class="info-row">
                                        <strong>Timestamp:</strong>
                                        <span>{{ attempt.request_body.timestamp || "N/A" }}</span>
                                    </div>
                                    <div class="info-row">
                                        <strong>ID Cotação:</strong>
                                        <span>{{ attempt.request_body.data ? attempt.request_body.data.quotation.id : "N/A" }}</span>
                                    </div>

                                    <h6 class="mt-3">Cabeçalhos</h6>
                                    <pre>{{ formatJson(attempt.request_headers) }}</pre>
                                </div>

                                <div class="col-md-6">
                                    <h6>Resposta</h6>
                                    <div class="info-row">
                                        <strong>Status HTTP:</strong>
                                        <span>{{ attempt.response_status || "N/A" }}</span>
                                    </div>
                                    <div class="info-row">
                                        <strong>Tempo de Resposta:</strong>
                                        <span>{{ attempt.response_time_ms }} ms</span>
                                    </div>

                                    <h6 class="mt-3">Corpo da Resposta</h6>
                                    <pre v-if="attempt.response_body">{{ formatJson(attempt.response_body) }}</pre>
                                    <pre v-else>Sem resposta</pre>

                                    <div v-if="!attempt.is_successful" class="mt-3">
                                        <h6>Mensagem de Erro</h6>
                                        <div class="alert alert-danger" style="font-size: 0.85rem">
                                            {{ attempt.error_message }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-3">
                                <div class="col-12">
                                    <h6>Corpo da Requisição</h6>
                                    <pre>{{ formatJson(attempt.request_body) }}</pre>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </template>
        </tbody>
    </table>
</template>

<script>
export default {
    props: {
        webhook_attempts: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    methods: {
        toggleDetails(idx) {
            this.$set(this.webhook_attempts[idx], "showDetails", !this.webhook_attempts[idx].showDetails);
        },
        formatJson(obj) {
            if (!obj) return "N/A";
            try {
                return JSON.stringify(obj, null, 2);
            } catch (e) {
                return obj;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.table {
    margin-top: 1rem;

    thead {
        background-color: #f7f7f7;
    }

    th {
        font-weight: 600;
        color: #505050;
        font-size: 0.95rem;
        padding: 0.75rem;
        border-bottom: 2px solid #e5e5e5;
    }

    td {
        padding: 0.75rem;
        vertical-align: middle;
        font-size: 0.9rem;
    }

    .status-badge {
        padding: 0.25rem 0.75rem;
        border-radius: 12px;
        font-size: 0.85rem;
        font-weight: 500;
        display: inline-block;

        &.success {
            background-color: #d4edda;
            color: #155724;
        }

        &.error {
            background-color: #f8d7da;
            color: #721c24;
        }
    }

    .method-badge {
        padding: 0.25rem 0.5rem;
        border-radius: 4px;
        font-size: 0.8rem;
        font-weight: 600;
        background-color: #17a2b8;
        color: white;
    }

    .details-btn {
        cursor: pointer;
        color: var(--primary-color);
        font-size: 1.2rem;
        transition: transform 0.2s;

        &:hover {
            transform: scale(1.2);
        }
    }
}

.details-section {
    background-color: #f9f9f9;
    border-left: 4px solid var(--primary-color);
    padding: 1rem;
    margin-top: 0.5rem;
    border-radius: 4px;

    h6 {
        font-weight: 600;
        color: #505050;
        margin-bottom: 0.75rem;
        font-size: 0.95rem;
    }

    pre {
        background-color: #2d2d2d;
        color: #f8f8f8;
        padding: 1rem;
        border-radius: 4px;
        overflow-x: auto;
        font-size: 0.85rem;
        max-height: 300px;
        margin-bottom: 0.5rem;
    }

    .info-row {
        display: flex;
        margin-bottom: 0.5rem;

        strong {
            min-width: 150px;
            color: #505050;
        }

        span {
            color: #666;
        }
    }
}
</style>
